import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:solutions.apps.dolomiteGeneral',
    'resource:solutions.apps.dolomiteGeneral.pages.chat',
    'resource:solutions.agents.dolomiteGeneral',
  ],
  description: 'Dolomite General',
  name: 'Dolomite General',
} as const satisfies core.quiver.Package
